import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../base-component'

const INPUT_SELECTOR = `[data-localization-input]`
const FORM_SELECTOR = 'form'

export class LocalizationSelector extends BaseComponent {
  mountComponent(): void {
    this.addListener(this, 'click', this.handleClick)
  }

  handleClick = (event: MouseEvent): void => {
    event.preventDefault()

    const target = event.target as HTMLElement

    if (target.hasAttribute(`data-localization-item`)) {
      const input: HTMLInputElement = $el(INPUT_SELECTOR, this)
      const form: HTMLFormElement = $el(FORM_SELECTOR, this)

      if (!input || !form || !target.dataset.value) {
        return
      }

      input.value = target.dataset.value
      form.submit()
    }
  }
}
